/* Product testimonial rails. */
document.addEventListener('click', event => {
  const button = event.target.closest('[data-ntp-prev], [data-ntp-next]');
  if (!button) return;
  const carousel = button.closest('[data-ntp-carousel]');
  const rail = carousel && carousel.querySelector('[data-ntp-rail]');
  const card = rail && rail.querySelector('.ntp-testimonial');
  if (!rail || !card) return;
  const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
  const distance = card.getBoundingClientRect().width + gap;
  rail.scrollBy({ left: button.hasAttribute('data-ntp-next') ? distance : -distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
});